import { takeEvery } from 'redux-saga/effects';

import * as actions from 'store/modules/extraPayments';

import { create } from './utils';

export default function* listenCreate() {
  yield takeEvery(actions.create.type, create);
}
